<template>
  <div class="compatibility" v-if="notSupport">
    <div class="container">
      <div class="text">
        当前浏览器因兼容性原因无法正常运行站点的部分重要功能，请使用谷歌Chrome浏览器打开网页
      </div>
      <div class="download">
        <div class="icon"></div>
        <div class="url">
          <span class="title">Chrome 浏览器</span>
          <br />
          <a href="https://www.google.cn/chrome/">立即下载</a>
        </div>
      </div>
    </div>
    <div class="close" @click="CloseHandle">
      <i class="el-icon-close"></i>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      notSupport: true
    };
  },
  created() {
    if (window) {
      // var browserInfo = this.$util.browserCompatibility();
      // // var ua = navigator.userAgent;
      // // this.getEngineVer(ua);
      this.checkBrowserCompatibility(this.$util.browserCompatibility);
    }
  },
  methods: {
    CloseHandle() {
      this.notSupport = false;
    },
    checkBrowserCompatibility(browserCompatibility) {
      var isBrowserCompatibility = browserCompatibility();
      if (
        isBrowserCompatibility != undefined &&
        isBrowserCompatibility != null
      ) {
        let browser = isBrowserCompatibility;
        if (browser.browserName == "Microsoft Internet Explorer") {
          this.notSupport = true;
        } else {
          this.notSupport = false;
        }
      } else {
        this.notSupport = true;
        // return false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.compatibility {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  // width: 100%;
  height: 100px;
  background-color: rgba(65, 89, 138, 0.7);
  color: #ddd;
  .container {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 800px;
    height: 100%;
    margin: 0 auto;
    line-height: 1.75;
  }
  .text {
    display: inline-block;
    width: 450px;
    height: 3em;
    border-right: 1px solid $font_white;
    padding-right: 40px;
    text-align: left;
  }
  .download {
    display: flex;
    align-items: center;
    .icon {
      display: inline-block;
      width: 64px;
      height: 64px;
      margin-right: 0.8em;
      background: url("../../../public/images/icon_chrome.png") no-repeat;
      background-size: contain;
    }
    .url {
      a {
        display: inline-block;
        padding: 0 2em;
        margin-top: 0.5em;
        background-color: $active_color;
        color: $font_white;
        line-height: 2;
      }
    }
  }
  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    color: $font_white;
    font-size: 1.5em;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
    &:active {
      opacity: 1;
    }
  }
}
</style>
